import {
  SERVICE_CATEGORY_ORDER,
  SERVICE_DEFINITIONS,
  type ServiceIcon,
} from "~/content/navigation/serviceCatalog";

export type ServiceNavIcon = ServiceIcon;

export type ServiceNavLink = {
  label: string;
  href: string;
  icon: ServiceNavIcon;
};

export type ServiceNavGroup = {
  heading: string;
  links: ServiceNavLink[];
};

export const SERVICE_NAV_GROUPS: ServiceNavGroup[] = SERVICE_CATEGORY_ORDER.map(
  (category) => ({
    heading: category,
    links: SERVICE_DEFINITIONS.filter((service) => service.category === category).map(
      (service) => ({
        label: service.navigationLabel ?? service.name,
        href: service.href,
        icon: service.icon,
      })
    ),
  })
);
